import { render, staticRenderFns } from "./detailsData.vue?vue&type=template&id=078949a8&scoped=true"
import script from "./detailsData.vue?vue&type=script&lang=js"
export * from "./detailsData.vue?vue&type=script&lang=js"
import style0 from "./detailsData.vue?vue&type=style&index=0&id=078949a8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078949a8",
  null
  
)

export default component.exports